// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.sessionStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    // userData: initialUser()
    userData: initialUser(),
    userData1: {}
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      sessionStorage.setItem('userData', JSON.stringify(action.payload))
      sessionStorage.setItem('token', action.payload.token)
      sessionStorage.setItem('menu', action.payload.menu)
      const organizzazioni = [...JSON.parse(JSON.stringify(action.payload.organizzazioni))]
      sessionStorage.setItem('organization', JSON.stringify(organizzazioni))
      const connectionOptions = JSON.parse(sessionStorage.getItem('organization'))
      const activeAgency = connectionOptions.map(el => ({ title: el.ragione_sociale, value: el.chiave }))
      sessionStorage.setItem('activeAgency', JSON.stringify(activeAgency[0]))
      sessionStorage.setItem('userLogged', action.payload.userLogged)
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from sessionStorage
      sessionStorage.removeItem('userData')
      sessionStorage.removeItem('token')
      // sessionStorage.removeItem(config.storageRefreshTokenKeyName)
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
